import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../theming/jssTypes';
import * as moment from 'moment';
import Modal from 'src/design-system/components/atoms/Modal/Modal';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: '300px',
    boxShadow: theme.shadow.sm,
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: theme.spacing[2],
    },
  },
  table: {
    marginLeft: theme.spacing[0],
  },
});

class PriceDataListModal extends React.Component<any, any> {
  generateDataColumns = () => {
    const columnData: any = [
      {
        title: 'S.No.',
        key: 'index',
        render: (text, record, index) => index + 1,
        width: 10,
      },
      {
        title: 'Charge Name',
        key: 'id',
        width: 40,
        render: (text, record) => record['name'] || record['id'] || '',
      },
      {
        title: 'Charge Amount',
        key: 'value',
        width: 30,
        render: (text, record) => record['value'] ?? '',
      },
    ];
    return columnData;
  };
  render() {
    const { isVisible, classes, priceDataList } = this.props;
    const header = 'Details';
    return (
      <Modal
        title={header}
        width="500px"
        visible={isVisible}
        footer={null}
        onCancel={() => this.props.handleModalClose(false)}
        destroyOnClose
      >
        <div className={classes.tableContainer}>
          <FixedHeaderTable
            locale={{ emptyText: 'No Data Found' }}
            pagination={false}
            columns={this.generateDataColumns()}
            dataSource={priceDataList}
            className={classes.table}
          />
        </div>
      </Modal>
    );
  }
}
export default withStyles(styles, { injectTheme: true })(PriceDataListModal);
